import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
import { ValidationContext } from '~/components/hoc/withValidation';
import { Stack } from '@qred/components-library';
import BankAccountList from './components/BankAccountList';
import AccountNumberInput from './components/AccountNumberInput';
import SelectPaymentMethod from './components/SelectPaymentMethod';
import { useOnboardingOfferSelectors } from '~/store/selectors/onboardingOffer.selector';
import { isEmptyObject } from '~/helpers/utils';

const BankInformation = () => {
  const validationContext = useContext(ValidationContext);

  const {
    onboardingOffer: { overview, form },
  } = useSelector((state: RootState) => state);

  const { hasSepaDirectDebitFeature } = useOnboardingOfferSelectors();

  const hasBankAccounts =
    overview.bankAccounts && overview.bankAccounts.length > 0;

  const [showAddNewAccountManually, setShowAddNewAccountManually] = useState(
    !!form.accountNumber || !hasBankAccounts
  );

  useEffect(() => {
    if (isEmptyObject(form.account) && !form.accountNumber) {
      validationContext.addPropertyToValidationErrors(
        'MissingAccountAndAccountNumber'
      );
    }

    return () => {
      validationContext.removePropertyFromValidationErrors(
        'MissingAccountAndAccountNumber'
      );
    };
  }, [form.account, form.accountNumber]);

  return (
    <Stack spacing={'xxl'}>
      <Stack spacing={'md'}>
        {hasBankAccounts && (
          <BankAccountList
            setShowAddNewAccount={setShowAddNewAccountManually}
            showAddNewAccount={showAddNewAccountManually}
          />
        )}

        {showAddNewAccountManually && <AccountNumberInput />}
      </Stack>

      {hasSepaDirectDebitFeature && <SelectPaymentMethod />}
    </Stack>
  );
};

export default BankInformation;
